import styled from 'styled-components'
import { HoverText } from '../../seat-picker/seat-picker-styles'

interface ButtonProps {
  disabled?: boolean
  isPrimary?: boolean
  maxContent?: boolean
  isCircle?: boolean
}

export const StyledButton = styled.button<ButtonProps>`
  display: flex;
  align-items: center;
  font-size: 18px;
  width: ${({ maxContent }) => (maxContent ? 'max-content' : '250px')};
  min-height: 48px;
  gap: 10px;
  padding: 10px 20px;
  border: ${props => (props.isPrimary ? 'none' : `solid 1px ${props.theme.colours.darkRed}`)};
  border-radius: 32px;
  color: ${props => (props.isPrimary ? props.theme.colours.white : props.theme.colours.charcoal)};
  cursor: ${({ disabled }) => !disabled && 'pointer'};

  background: ${props => props.disabled && props.theme.colours.midGrey};
  background: ${props => !props.disabled && props.isPrimary && props.theme.colours.darkRed};
  background: ${props => !props.disabled && !props.isPrimary && props.theme.colours.white};

  @media (min-width: ${props => props.theme.breakpoints.lg}px) {
    width: ${({ maxContent }) => (maxContent ? 'max-content' : '210px')};
  }

  @media (max-width: ${props => props.theme.breakpoints.lg}px) {
    width: 250px;
  }

  &:hover {
    background: ${props => !props.disabled && props.isPrimary && props.theme.colours.burnRed};
    background: ${props =>
      props.isCircle && !props.disabled && !props.isPrimary && props.theme.colours.charcoal};
    background: ${props =>
      !props.disabled && !props.isCircle && !props.isPrimary && props.theme.colours.white};

    border: ${props =>
      !props.disabled && !props.isPrimary && `solid 1px ${props.theme.colours.burnRed}`};
    border: ${props =>
      !props.disabled &&
      !props.isPrimary &&
      props.isCircle &&
      `solid 1px ${props.theme.colours.charcoal}`};

    color: ${props =>
      !props.disabled && !props.isPrimary && props.isCircle && props.theme.colours.white};

    div ~ div {
      background-color: ${props =>
        !props.disabled && !props.isPrimary && props.theme.colours.darkRed};
    }
  }
`

export const BookingStyledButton = styled.button<ButtonProps>`
  display: flex;
  align-items: center;
  flex-direction: column;
  font-size: 18px;
  width: 120px;
  height: 130px;
  border: none;
  border-radius: 10px;
  box-shadow: 0px 2px 5px rgba(17, 17, 17, 0.08);
  color: ${props => (props.disabled ? 'grey' : props.theme.colours.charcoal)};
  cursor: ${({ disabled }) => !disabled && 'pointer'};
  background: ${props => props.theme.colours.white};
  &:hover {
    background-color: #ebebeb;
    opacity: 93%;
    ${HoverText} {
      visibility: visible;
      bottom: 25px;
    }
  }
`

export const ButtonContent = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  flex: 1;
  font-family: 'Roboto';
  font-style: normal;
  font-size: 18px;
  line-height: 27px;
  text-align: center;
`

export const BookingButtonContent = styled.div`
  display: flex;
  padding: 25px;
  align-items: center;
  justify-content: flex-end;
  flex-direction: column;
  flex: 1;
`
export const BookingButtonTextRow = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  flex: 1;
`
export const Arrow = styled.a<ButtonProps>`
  font-size: 16px;
  color: ${props =>
    props.isCircle
      ? props.isPrimary
        ? props.theme.colours.red
        : props.theme.colours.white
      : props.isPrimary
      ? props.theme.colours.white
      : props.theme.colours.red};

  color: ${props => props.disabled && props.theme.colours.charcoal};
  color: ${props =>
    !props.disabled && !props.isPrimary && props.isCircle && props.theme.colours.white};
`

export const ArrowWrapper = styled.div<ButtonProps>`
  display: flex;
  float: right;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  margin-left: ${({ maxContent }) => (maxContent ? '10px' : '0')};
  height: 30px;
  width: 30px;

  background-color: ${props =>
    props.disabled
      ? props.theme.colours.lightGrey
      : props.isPrimary
      ? props.theme.colours.white
      : props.theme.colours.darkRed};
  background-color: ${props => !props.disabled && !props.isPrimary && props.theme.colours.charcoal};
`
